// Auto-generated file - Do not edit manually
export const APP_VERSION = {
  frontend: '2.18.1-RC1',
  buildDate: '2026-11-03',
  environment: 'production'
};
